import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
  HostListener,
} from "@angular/core";
import { FabricjsEditorComponent } from "../../../projects/angular-editor-fabric-js/src/lib/angular-editor-fabric-js.component";
import { BuilderService } from "../services/builder.service";
import { UtilService } from "../util.service";
// @ts-ignore
import LineClamp from "@tvanc/lineclamp";
import { DOCUMENT } from "@angular/common";
import { ApiService } from "../services/api.service";
import { AppConstants } from "../../AppConstants";

@Component({
  selector: "app-junior-sticker-builder",
  templateUrl: "./junior-sticker-builder.component.html",
  styleUrls: ["./junior-sticker-builder.component.scss"],
})
export class JuniorStickerBuilderComponent implements OnInit, AfterViewInit {
  @ViewChild("canvas", { static: false }) canvas: FabricjsEditorComponent;
  @ViewChild("clampedElement") clampedElement: ElementRef;
  public childClipArt = [];
  public tabsClipArt: any;
  /** Background swatches in palette order: 3 per series (rows), last series has one swatch. */
  bgColor: { name: string; hex: string }[] = [
    { name: "lemon", hex: "#f3e204" },
    { name: "sunflower", hex: "#fdc40e" },
    { name: "canary", hex: "#ffde00" },
    { name: "cream", hex: "#faed90" },
    { name: "harvestGold", hex: "#deb626" },
    { name: "tangerine", hex: "#ef8d1c" },
    { name: "flame", hex: "#e8631f" },
    { name: "apricot", hex: "#ffa43e" },
    { name: "peach", hex: "#f9c699" },
    { name: "copper", hex: "#c17325" },
    { name: "crimson", hex: "#e12421" },
    { name: "berry", hex: "#c5037c" },
    { name: "coral", hex: "#ff8d8d" },
    { name: "blush", hex: "#ffd0d0" },
    { name: "brick", hex: "#b74345" },
    { name: "plum", hex: "#6c3a89" },
    { name: "indigo", hex: "#454e98" },
    { name: "lilac", hex: "#ca9ff1" },
    { name: "lavender", hex: "#eddcfa" },
    { name: "mauve", hex: "#7c5e90" },
    { name: "cobalt", hex: "#2972ae" },
    { name: "teal", hex: "#0795bb" },
    { name: "sky", hex: "#8fc3ed" },
    { name: "ice", hex: "#c6e4fa" },
    { name: "navy", hex: "#003961" },
    { name: "emerald", hex: "#008d5b" },
    { name: "lime", hex: "#8bba25" },
    { name: "sage", hex: "#7fad94" },
    { name: "moss", hex: "#9fc18b" },
    { name: "forest", hex: "#29522b" },
    { name: "ivory", hex: "#fdf0dd" },
    { name: "linen", hex: "#f4efec" },
    { name: "espresso", hex: "#411900" },
    { name: "taupe", hex: "#a78a69" },
    { name: "sand", hex: "#d7ba96" },
    { name: "black", hex: "#000000" },
    { name: "white", hex: "#ffffff" },
    { name: "charcoal", hex: "#3c3e3f" },
    { name: "slate", hex: "#5a5b5b" },
    { name: "stone", hex: "#b6aca3" },
  ];
  bgImage = {
    // tslint:disable-next-line:max-line-length
    imgUrl: "./assets/bg-img/1.jpg",
    imgUrl2: "./assets/bg-img/2.jpg",
    imgUrl3: "./assets/bg-img/3.jpg",
    imgUrl4: "./assets/bg-img/4.jpg",
  };
  public BASE_URL = AppConstants.BASE_URL;
  pikaImg = "";
  pikaEvent: any;
  bgUrl = "";
  color = "";
  textAlign = "center";
  fontFamily = "Poppins";
  /** Base CSS font-weight for the selected font (bold toggle uses synthetic bold). */
  juniorBaseFontWeight: string | number = 500;
  isBold = false;
  isItalicText = false;
  textColor = "#000000";
  texts = {
    line1: {
      text: "",
      size: "16px",
      lineHeight: "16px",
      canvasSize: 50,
    },
    line2: {
      text: "",
      size: "16px",
      lineHeight: "16px",
      canvasSize: 50,
    },
    line3: {
      text: "",
      size: "16px",
    },
  };
  text1 = {
    text: "",
    size: "",
  };
  text2 = "";
  text3 = "";
  textDetails: any;
  type1: any;
  type2: any;
  type3: any;
  juniorSize = {
    width: 15,
    height: 5,
    type: 1,
    quantity: 150,
  };
  private clamp: any;
  // Define the flag with default value false for place order savePDF call
  public saveFlag: boolean = false;

  constructor(
    public builder: BuilderService,
    public util: UtilService,
    private api: ApiService,
    private renderer: Renderer2,
    private el: ElementRef,
    @Inject(DOCUMENT) private document: HTMLDocument
  ) {}

  isTablet = window.innerWidth < 769;
  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.builder.canvas = this.canvas;
    this.changeSize();
    this.getChildClipArt();
    this.builder.canvas.clear();
    if (this.util.isMobile) {
      // Fetch width data of child-sticker-parent by ID to manage ratio
      const childStickerParent = this.el.nativeElement.querySelector(
        "#child-sticker-parent"
      );
      if (childStickerParent) {
        const width = childStickerParent.offsetWidth;
        console.log("kkk1 width", width);

        // Calculate new height
        const newHeight = window.innerWidth / 3;
        console.log("kkk1 newHeight", newHeight);

        // Set new height to child-sticker-parent
        this.renderer.setStyle(childStickerParent, "height", `${newHeight}px`);
        this.renderer.setStyle(
          childStickerParent,
          "min-height",
          `${newHeight}px`
        );

        // Resize canvas
        this.canvas.changeChildSize(width, newHeight);
      }
    } else {
      this.builder.canvas.changeChildSize(600, 200);
    }

    // Set physical size so 3mm padding is applied by default (background, image, text all inside 3mm)
    this.applyChildStickerSizeInCm();
    // this.clampText();
  }

  /** Set canvas sizeInCm from juniorSize so 3mm padding is used for all content (background, image, text). */
  private applyChildStickerSizeInCm(): void {
    if (!this.builder.canvas) return;
    this.builder.canvas.sizeInCm.width = this.juniorSize.type === 1 ? 15 : 30;
    this.builder.canvas.sizeInCm.height = this.juniorSize.type === 1 ? 5 : 10;
  }
  @HostListener("window:scroll", ["$event"])
  onWindowScroll(event): void {
    // Get the scroll position
    const scrollPosition =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    // Get the element you want to modify
    const stickyImageSection =
      this.el.nativeElement.querySelector(".stickyImageSec");
    const addMarginTop = this.el.nativeElement.querySelector(".addMarginTop");

    const stickyParentDiv =
      this.el.nativeElement.querySelector(".stickyParentDiv");
    const rect = stickyParentDiv.getBoundingClientRect();

    // Calculate the position based on the top of the viewport
    const positionFromTop = rect.top;
    //console.log("positionFromTop - ", positionFromTop);

    // Check if the scroll position is beyond the threshold
    if (scrollPosition > positionFromTop) {
      // Add the desired class when scrolling down
      if (stickyImageSection) {
        this.renderer.addClass(stickyImageSection, "addSticky");
      }
      if (addMarginTop) {
        this.renderer.addClass(addMarginTop, "addMarginTopS");
      }
    } else {
      // Remove the class when scrolling back to the top
      if (addMarginTop) {
        this.renderer.removeClass(addMarginTop, "addMarginTopS");
      }
      if (stickyImageSection) {
        this.renderer.removeClass(stickyImageSection, "addSticky");
      }
    }
  }

  public changeSize() {
    this.canvas.changeChildSize(1133.86, 566.93);
  }

  clampText() {
    const element = this.clampedElement.nativeElement;
    this.clamp = new LineClamp(element, {
      maxLines: 1,
    });
    const listener = (event) => console.log(event.type);

    element.addEventListener("lineclamp.softclamp", listener);
    element.addEventListener("lineclamp.hardclamp", listener);
    element.addEventListener("lineclamp.clamp", listener);

    // softClamp() emits 'lineclamp.softclamp' and 'lineclamp.clamp', or nothing
    // if clamping unnecessary
    this.clamp.softClamp();

    // hardClamp() emits 'lineclamp.hardclamp' and 'lineclamp.clamp', or nothing
    // if clamping unnecessary
    this.clamp.hardClamp();

    // apply() can emit 'lineclamp.softclamp' and/or 'lineclamp.hardclamp' followed
    // by 'lineclamp.clamp', or nothing if clamping is unnecessary
    this.clamp.apply();
  }

  public getImgPolaroid(event) {
    this.pikaEvent = event;
    // this.builder.canvas.getChildImgPolaroid(event);
    const ele = event.target;
    this.pikaImg = ele.src;
    const image = this.pikaImg.length > 1;
    this.singleLineSticker(image);
    setTimeout(() => {
      this.save();
    }, 200);
    //this.reRenderWithImage();
    // this.canvas.ge
  }

  reRenderWithImage() {
    const textExists = this.util.textExists(this.texts);
    if (textExists) {
      const size = this.util.getFontSize(
        this.texts.line1.text,
        true,
        1,
        this.texts
      );
      this.texts.line1.size = size;
      this.texts.line2.size = size;
      this.texts.line3.size = size;
    } else {
      console.log("No change required!");
    }
  }

  public setCanvasFill(color) {
    this.color = color;
    this.bgUrl = "";
    this.canvas.props.canvasFill = color;
    this.save();

    // this.builder.canvas.setCanvasFill();
  }

  public setCanvasImage(url) {
    this.bgUrl = url;
    this.save();
    // this.builder.canvas.setBackgroundImage(url);
  }

  addText(text, type) {
    switch (type) {
      case 1:
        this.text1.text = text;
        this.texts.line1.text = text;
        break;
      case 2:
        this.text2 = text;
        this.texts.line2.text = text;
        break;
      case 3:
        this.texts.line3.text = text;
        break;
    }
    const image = this.pikaImg.length > 1;
    this.singleLineSticker(image);
    this.save();
  }
  getTextWidth(text, font) {
    let gettextwidth = this.getTextWidth;
    // re-use canvas object for better performance
    const canvas = <HTMLCanvasElement>document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  }

  getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
  }
  singleLineSticker(img) {
    const hasTwoLines = this.texts.line2.text.length > 0;
    const line1Text = this.texts.line1.text || "";
    const line2Text = this.texts.line2.text || "";
    // When two lines are present use a smaller base font so both fit; otherwise use larger single-line size
    const baseCanvasSize = hasTwoLines ? (img ? 90 : 60) : (img ? 150 : 100);
    this.texts.line1.size = img ? "150px" : "150px";
    this.texts.line1.canvasSize = baseCanvasSize;
    this.texts.line1.lineHeight = img ? "150px" : "100px";

    const text_section = document.getElementById("text-section");
    if (!text_section) return;
    const positionInfo = text_section.getBoundingClientRect();
    const canvaswidth = positionInfo.width - 20;
    const fontweight = this.isBold
      ? "bold"
      : String(this.juniorBaseFontWeight);
    // Use the longer line for width fitting when two lines
    const measureText = hasTwoLines
      ? (line1Text.length >= line2Text.length ? line1Text : line2Text)
      : line1Text;
    let textwidth = this.getTextWidth(
      measureText,
      fontweight + " " + this.texts.line1.canvasSize + "px '" + this.fontFamily + "'"
    );
    let canvasSize = this.texts.line1.canvasSize;
    while (textwidth > canvaswidth && canvasSize > 8) {
      canvasSize = canvasSize - 1;
      textwidth = this.getTextWidth(
        measureText,
        fontweight + " " + canvasSize + "px '" + this.fontFamily + "'"
      );
    }
    const finalSize = Math.max(8, canvasSize - 4);
    this.texts.line1.size = finalSize + "px";
    this.texts.line1.canvasSize = finalSize;
    this.texts.line1.lineHeight = finalSize + "px";
    if (hasTwoLines) {
      this.texts.line2.size = finalSize + "px";
      this.texts.line2.lineHeight = finalSize + "px";
      this.texts.line2.canvasSize = finalSize;
    }
    if (this.juniorSize.type === 2) {
      this.texts.line1.canvasSize = this.texts.line1.canvasSize * 2;
      if (hasTwoLines) {
        this.texts.line2.canvasSize = this.texts.line2.canvasSize * 2;
      }
    }
    if (this.util.isMobile && img) {
      const size = Number(this.texts.line1.size.replace("px", ""));
      this.texts.line1.size = size / 2 + "px";
      this.texts.line1.canvasSize = size / 2;
      this.texts.line1.lineHeight = size / 2 + "px";
      if (hasTwoLines) {
        this.texts.line2.size = size / 2 + "px";
      }
    } else if (img) {
      const size = Number(this.texts.line1.size.replace("px", ""));
      this.texts.line1.size = size / 1.5 + "px";
      this.texts.line1.canvasSize = size / 1.5;
      this.texts.line1.lineHeight = size / 1.5 + "px";
      if (hasTwoLines) {
        this.texts.line2.size = size / 1.5 + "px";
      }
    }
  }

  public setFontFamily(value: HTMLSelectElement) {
    this.fontFamily = value.value;
    const opt = value.selectedOptions[0];
    const w = opt?.getAttribute("data-font-weight");
    this.juniorBaseFontWeight = w ? parseInt(w, 10) : 400;
    this.builder.canvas.setFontFamilyJunior(this.fontFamily);
    const image = this.pikaImg.length > 1;
    this.singleLineSticker(image);
    this.save();
  }

  public setTextAlign(value) {
    this.textAlign = value;
    // this.builder.canvas.setTextAlign(value);
    this.save();
  }

  public setBold() {
    this.isBold = !this.isBold;
    this.save();
  }

  public setFontStyle() {
    this.isItalicText = !this.isItalicText;
    // this.builder.canvas.setFontStyle();
    this.save();
  }

  public setFill(event) {
    this.textColor = event;
    // this.builder.canvas.setFill();
    this.save();
  }

  save() {
    // Set physical size first so 3mm padding is applied to image and text (all content under 3mm space)
    this.applyChildStickerSizeInCm();

    // this.builder.canvas.clear();

    // var childStickerParent = document.getElementById("child-sticker-parent");

    // // Get the bounding rectangles of both elements
    // let childStickerParentRect = childStickerParent.getBoundingClientRect();
    // // Fix size will be used so PDF created always in the same size
    // this.builder.canvas.changeChildSize(
    //   childStickerParentRect.width,
    //   childStickerParentRect.height
    // );
    // this.builder.canvas.changeSize();
    const sticker =
      this.text1.text.length > 0 &&
      this.text2.length > 0 &&
      this.text3.length > 0 &&
      this.pikaImg.length > 0;
    // Here we getting the width and height of added text so when creating canvas/PDF we can put the same size.
    var get_text_length = document.getElementById("child-sticker-text");
    var getTextLengthInfo = get_text_length?.getBoundingClientRect();

    const hasTwoLines = this.texts.line2.text.length > 0;
    const combinedText = hasTwoLines
      ? this.texts.line1.text + "\n" + this.texts.line2.text
      : this.texts.line1.text;

    this.textDetails = {
      text: [
        {
          text: combinedText,
          type: 1,
          size: this.texts.line1.size,
          canvasSize: this.texts.line1.canvasSize,
          width: getTextLengthInfo ? getTextLengthInfo.width : 0,
          height: getTextLengthInfo ? getTextLengthInfo.height : 0,
        },
      ],
      textAlign: this.textAlign,
      bold: this.isBold,
      italic: this.isItalicText,
      background: this.color,
      bgUrl: this.bgUrl,
      color: this.textColor,
      image: this.pikaImg,
      event: this.pikaEvent,
      fontFamily: this.fontFamily,
      fontWeight: this.isBold ? 700 : this.juniorBaseFontWeight,
      type: this.juniorSize.type,
    };

    if (this.textDetails.event) {
      this.builder.canvas.getChildImgPolaroid(
        this.textDetails.event,
        this.util.getLineSum(this.texts)
      );
    }

    setTimeout(() => {
      this.builder.canvas.addJuniorText(
        this.textDetails,
        this.textDetails.event,
        this.texts
      );
    }, 500);
    if (this.textDetails.bgUrl) {
      this.builder.canvas.setBackgroundImage(this.textDetails.bgUrl);
    } else {
      this.builder.canvas.setCanvasFill("child_sticker");
    }

    this.builder.stickerDetails = {
      customSize: false,
      customSizes: false,
      fileEvent: undefined,
      material: undefined,
      name: undefined,
      pdf: undefined,
      piecePrice: undefined,
      pieces: this.juniorSize.quantity,
      // @ts-ignore
      size: {
        height: this.juniorSize.type === 1 ? 5 : 10,
        width: this.juniorSize.type === 1 ? 15 : 30,
      },
      stickerNumber: undefined,
    };
    this.builder.stickerDetails.name = {
      id: 0,
      image: "",
      selected: false,
      value: "",
      name: "nameTag",
    };
    this.builder.stickerDetails.stickerNumber = {
      amount: 20,
      createdAt: undefined,
      enable: false,
      price: this.juniorSize.type === 1 ? 18 : 18,
      publishedAt: undefined,
      updatedAt: undefined,
      piece: this.juniorSize.quantity,
    };

    if (this.saveFlag) {
      this.builder.canvas.savePdf();
      // Reset the flag after place order
      this.saveFlag = false;
    }
    // this.router.navigateByUrl('/place-order?type=junior-sticker');
  }

  selectJuniorSize(size: number) {
    if (size === 1) {
      this.juniorSize.width = 15;
      this.juniorSize.height = 5;
      this.juniorSize.quantity = 150;
      this.juniorSize.type = 1;
      this.util.juniorSize = 1;
    } else {
      this.juniorSize.width = 30;
      this.juniorSize.height = 10;
      this.juniorSize.quantity = 120;
      this.juniorSize.type = 2;
      this.util.juniorSize = 2;
    }
    // Keep 3mm padding correct when user changes sticker size
    this.applyChildStickerSizeInCm();
  }

  clearCanvas() {
    this.builder.canvas.clear();
    this.pikaImg = "";
    this.pikaEvent = undefined;
    this.bgUrl = "";
    this.color = "";
    this.textAlign = "";
    this.fontFamily = "";
    this.juniorBaseFontWeight = 500;
    this.isBold = false;
    this.isItalicText = false;
    this.textColor = "";
    this.text1 = {
      text: "",
      size: "",
    };
    this.text1 = {
      text: "",
      size: "",
    };
    this.text1 = {
      text: "",
      size: "",
    };
    this.text2 = "";
    this.text3 = "";
    this.texts.line1.text = "";
    this.texts.line2.text = "";
    this.texts.line3.text = "";
    this.textDetails = undefined;
    this.type1 = undefined;
    this.type2 = undefined;
    this.type3 = undefined;
  }

  noText() {
    return (
      this.texts.line1.text.length === 0 &&
      this.texts.line2.text.length === 0 &&
      this.texts.line3.text.length === 0
    );
  }

  /**
   * Get Child Cliparts
   */

  getChildClipArt() {
    this.api.getChildClipart().subscribe(
      (clipArtData) => {
        this.childClipArt = clipArtData.data;
        //this.tabsClipArt= this.formatedTabs();
        //console.log(this.tabsClipArt);
      },
      (error) => {
        console.log("ERROR Child Clipart", error);
      }
    );
  }
  objectKey(obj) {
    return Object.keys(obj);
  }
  formatedTabs() {
    return this.childClipArt.reduce((prev, now) => {
      if (!prev[now.attributes.tabgroup]) {
        prev[now.attributes.tabgroup] = [];
      }
      prev[now.attributes.tabgroup].push(now);
      return prev;
    }, {});
  }
}
